import { UserInfo } from './../a1/user/user-models';
import { createStore } from 'vuex'

export default createStore({
  state: {
    _username: "",
    _isMenuOpen: false,
  },

  getters: {
    isAuthenticated: (state) => {
      return state._username ? true : false;
    },

    username: (state) => state._username,
    isMenuOpen: (state) => state._isMenuOpen,
  },

  mutations: {
    setUser(state, userInfo: UserInfo) {
      state._username = userInfo.username;
    },
  },

  actions: {
  },

  modules: {
  },
})
